import React from 'react'

export interface NpsWidgetProps {
  value: number | null
  onChange: (value: number) => void
  disabled?: boolean
}

function getNpsColor(
  score: number,
  isActive: boolean,
): string {
  if (!isActive) {
    return 'border-neutral-300 bg-neutral-0 text-neutral-700 hover:border-neutral-400 hover:bg-neutral-50'
  }
  if (score <= 6) {
    return 'border-error-base bg-error-base text-neutral-0'
  }
  if (score <= 8) {
    return 'border-warning-base bg-warning-base text-neutral-0'
  }
  return 'border-success-base bg-success-base text-neutral-0'
}

export function NpsWidget({
  value,
  onChange,
  disabled = false,
}: NpsWidgetProps): React.ReactElement {
  const scores = Array.from({ length: 11 }, (_, i) => i)

  return (
    <div data-testid="nps-widget" className="font-sans">
      <div
        role="radiogroup"
        aria-label="Net Promoter Score from 0 to 10"
        className="flex items-center gap-1"
      >
        {scores.map((score) => {
          const isSelected = value === score

          return (
            <button
              key={score}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={`${score} out of 10`}
              disabled={disabled}
              className={[
                'flex items-center justify-center rounded-lg border text-sm font-medium transition-colors',
                'w-10 h-10',
                'focus:outline-hidden focus:ring-2 focus:ring-brand-500 focus:ring-offset-2',
                getNpsColor(score, isSelected),
                disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
              ].join(' ')}
              onClick={() => onChange(score)}
              data-testid={`nps-score-${score}`}
            >
              {score}
            </button>
          )
        })}
      </div>

      <div className="flex justify-between mt-2 text-xs text-neutral-500">
        <span data-testid="nps-label-low">Not likely</span>
        <span data-testid="nps-label-high">Very likely</span>
      </div>
    </div>
  )
}
